// I AM AUTO-GENERATED, DON'T CHECK ME INTO SUBVERSION (or else...)

import {ProtocolObject, ByteArray, ObjectFactory} from "./styx-api";


export class VersionPacket implements ProtocolObject {
    static CLASSID : number =  0;

    classId() {

        return VersionPacket.CLASSID;
    }
    public game : number;
    public operatorid : number;
    public protocol : number;

    constructor(game? : number, operatorid? : number, protocol? : number) {
        this.game = game;
        this.operatorid = operatorid;
        this.protocol = protocol;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.game);
        ba.writeInt(this.operatorid);
        ba.writeInt(this.protocol);
    }

    public load(ba : ByteArray) : void {
        this.game = ba.readInt();
        this.operatorid = ba.readInt();
        this.protocol = ba.readInt();
    }
}
export class GameVersionPacket implements ProtocolObject {
    static CLASSID : number =  1;

    classId() {

        return GameVersionPacket.CLASSID;
    }
    public game : number;
    public operatorid : number;
    public version : string;

    constructor(game? : number, operatorid? : number, version? : string) {
        this.game = game;
        this.operatorid = operatorid;
        this.version = version;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.game);
        ba.writeInt(this.operatorid);
        ba.writeString(this.version);
    }

    public load(ba : ByteArray) : void {
        this.game = ba.readInt();
        this.operatorid = ba.readInt();
        this.version = ba.readString();
    }
}
export class GoodPacket implements ProtocolObject {
    static CLASSID : number =  2;

    classId() {

        return GoodPacket.CLASSID;
    }
    public cmd : number;
    public extra : number;

    constructor(cmd? : number, extra? : number) {
        this.cmd = cmd;
        this.extra = extra;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.cmd);
        ba.writeInt(this.extra);
    }

    public load(ba : ByteArray) : void {
        this.cmd = ba.readByte();
        this.extra = ba.readInt();
    }
}
export class BadPacket implements ProtocolObject {
    static CLASSID : number =  3;

    classId() {

        return BadPacket.CLASSID;
    }
    public cmd : number;
    public error : number;

    constructor(cmd? : number, error? : number) {
        this.cmd = cmd;
        this.error = error;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.cmd);
        ba.writeByte(this.error);
    }

    public load(ba : ByteArray) : void {
        this.cmd = ba.readByte();
        this.error = ba.readByte();
    }
}
export class SystemMessagePacket implements ProtocolObject {
    static CLASSID : number =  4;

    classId() {

        return SystemMessagePacket.CLASSID;
    }
    public type : number;
    public level : number;
    public message : string;
    public messageCode : number;
    pids : number[]  = [];

    constructor(type? : number, level? : number, message? : string, messageCode? : number, pids? : number[]) {
        this.type = type;
        this.level = level;
        this.message = message;
        this.messageCode = messageCode;
        this.pids = pids;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.type);
        ba.writeInt(this.level);
        ba.writeString(this.message);
        ba.writeInt(this.messageCode);
        ba.writeInt(this.pids.length);
        for(let i = 0; i != this.pids.length; ++i) {
            ba.writeInt(this.pids[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.type = ba.readInt();
        this.level = ba.readInt();
        this.message = ba.readString();
        this.messageCode = ba.readInt();
        let pidsCount : number = ba.readInt();
        this.pids = [];
        for (let i = 0; i < pidsCount; i ++) {
            this.pids.push(ba.readInt());
        }
    }
}
export class Param implements ProtocolObject {
    static CLASSID : number =  5;

    classId() {

        return Param.CLASSID;
    }
    public key : string;
    public type : number;
    public value : number[];

    constructor(key? : string, type? : number, value? : number[]) {
        this.key = key;
        this.type = type;
        this.value = value;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.key);
        ba.writeByte(this.type);
        ba.writeInt(this.value.length);
        for(let i = 0; i != this.value.length; ++i) {
            ba.writeUnsignedByte(this.value[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.key = ba.readString();
        this.type = ba.readByte();
        let a = ba.readInt();
        this.value = ba.readArray(a);
    }
}
export class ParamFilter implements ProtocolObject {
    static CLASSID : number =  6;

    classId() {

        return ParamFilter.CLASSID;
    }
    public param : Param;
    public op : number;

    constructor(param? : Param, op? : number) {
        this.param = param;
        this.op = op;
    }

    public save(ba : ByteArray) :  void {
        this.param.save(ba);
        ba.writeByte(this.op);
    }

    public load(ba : ByteArray) : void {
        this.param = new Param();
        this.param.load(ba);
        this.op = ba.readByte();
    }
}
export class PingPacket implements ProtocolObject {
    static CLASSID : number =  7;

    classId() {

        return PingPacket.CLASSID;
    }
    public id : number;

    constructor(id? : number) {
        this.id = id;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.id);
    }

    public load(ba : ByteArray) : void {
        this.id = ba.readInt();
    }
}
export class Attribute implements ProtocolObject {
    static CLASSID : number =  8;

    classId() {

        return Attribute.CLASSID;
    }
    public name : string;
    public value : string;

    constructor(name? : string, value? : string) {
        this.name = name;
        this.value = value;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.name);
        ba.writeString(this.value);
    }

    public load(ba : ByteArray) : void {
        this.name = ba.readString();
        this.value = ba.readString();
    }
}
export class LoginRequestPacket implements ProtocolObject {
    static CLASSID : number =  10;

    classId() {

        return LoginRequestPacket.CLASSID;
    }
    public user : string;
    public password : string;
    public operatorid : number;
    public credentials : number[];

    constructor(user? : string, password? : string, operatorid? : number, credentials? : number[]) {
        this.user = user;
        this.password = password;
        this.operatorid = operatorid;
        this.credentials = credentials;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.user);
        ba.writeString(this.password);
        ba.writeInt(this.operatorid);
        ba.writeInt(this.credentials.length);
        for(let i = 0; i != this.credentials.length; ++i) {
            ba.writeUnsignedByte(this.credentials[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.user = ba.readString();
        this.password = ba.readString();
        this.operatorid = ba.readInt();
        let a = ba.readInt();
        this.credentials = ba.readArray(a);
    }
}
export class JwtAuthPacket implements ProtocolObject {
    static CLASSID : number =  20;

    classId() {

        return JwtAuthPacket.CLASSID;
    }
    public jwt : string;

    constructor(jwt? : string) {
        this.jwt = jwt;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.jwt);
    }

    public load(ba : ByteArray) : void {
        this.jwt = ba.readString();
    }
}
export class LoginResponsePacket implements ProtocolObject {
    static CLASSID : number =  11;

    classId() {

        return LoginResponsePacket.CLASSID;
    }
    public screenname : string;
    public pid : number;
    public status : ResponseStatus = 0;
    public code : number;
    public message : string;
    public credentials : number[];
    public remoteAddress : string;
    public remotePort : number;

    constructor(screenname? : string, pid? : number, status? : ResponseStatus, code? : number, message? : string, credentials? : number[], remoteAddress? : string, remotePort? : number) {
        this.screenname = screenname;
        this.pid = pid;
        this.status = status;
        this.code = code;
        this.message = message;
        this.credentials = credentials;
        this.remoteAddress = remoteAddress;
        this.remotePort = remotePort;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.screenname);
        ba.writeInt(this.pid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        ba.writeInt(this.code);
        ba.writeString(this.message);
        ba.writeInt(this.credentials.length);
        for(let i = 0; i != this.credentials.length; ++i) {
            ba.writeUnsignedByte(this.credentials[i]);
        }
        ba.writeString(this.remoteAddress);
        ba.writeInt(this.remotePort);
    }

    public load(ba : ByteArray) : void {
        this.screenname = ba.readString();
        this.pid = ba.readInt();
        this.status = ba.readUnsignedByte();
        this.code = ba.readInt();
        this.message = ba.readString();
        let a = ba.readInt();
        this.credentials = ba.readArray(a);
        this.remoteAddress = ba.readString();
        this.remotePort = ba.readInt();
    }
}
export class LogoutPacket implements ProtocolObject {
    static CLASSID : number =  12;

    classId() {

        return LogoutPacket.CLASSID;
    }
    public leaveTables : boolean;

    constructor(leaveTables? : boolean) {
        this.leaveTables = leaveTables;
    }

    public save(ba : ByteArray) :  void {
        ba.writeBoolean(this.leaveTables);
    }

    public load(ba : ByteArray) : void {
        this.leaveTables = ba.readBoolean();
    }
}
export class PlayerInfoPacket implements ProtocolObject {
    static CLASSID : number =  13;

    classId() {

        return PlayerInfoPacket.CLASSID;
    }
    public pid : number;
    public nick : string;
    public details : Param[];

    constructor(pid? : number, nick? : string, details? : Param[]) {
        this.pid = pid;
        this.nick = nick;
        this.details = details;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.pid);
        ba.writeString(this.nick);
        if (!this.details) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.details.length);
            for(let i = 0; i != this.details.length; ++i)
                this.details[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.pid = ba.readInt();
        this.nick = ba.readString();
        let detailsCount : number = ba.readInt();
        this.details = [];
        for(let i = 0; i != detailsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.details.push(_tmp);
        }
    }
}
export class ForcedLogoutPacket implements ProtocolObject {
    static CLASSID : number =  14;

    classId() {

        return ForcedLogoutPacket.CLASSID;
    }
    public code : number;
    public message : string;

    constructor(code? : number, message? : string) {
        this.code = code;
        this.message = message;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.code);
        ba.writeString(this.message);
    }

    public load(ba : ByteArray) : void {
        this.code = ba.readInt();
        this.message = ba.readString();
    }
}
export class SeatInfoPacket implements ProtocolObject {
    static CLASSID : number =  15;

    classId() {

        return SeatInfoPacket.CLASSID;
    }
    public tableid : number;
    public seat : number;
    public status : PlayerStatus = 0;
    public player : PlayerInfoPacket;

    constructor(tableid? : number, seat? : number, status? : PlayerStatus, player? : PlayerInfoPacket) {
        this.tableid = tableid;
        this.seat = seat;
        this.status = status;
        this.player = player;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        this.player.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        this.status = ba.readUnsignedByte();
        this.player = new PlayerInfoPacket();
        this.player.load(ba);
    }
}
export class SystemInfoRequestPacket implements ProtocolObject {
    static CLASSID : number =  18;

    classId() {

        return SystemInfoRequestPacket.CLASSID;
    }

    constructor() {
    }

    public save(ba : ByteArray) :  void {
    }

    public load(ba : ByteArray) : void {
    }
}
export class SystemInfoResponsePacket implements ProtocolObject {
    static CLASSID : number =  19;

    classId() {

        return SystemInfoResponsePacket.CLASSID;
    }
    public players : number;
    public params : Param[];

    constructor(players? : number, params? : Param[]) {
        this.players = players;
        this.params = params;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.players);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.players = ba.readInt();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
    }
}
export class JoinRequestPacket implements ProtocolObject {
    static CLASSID : number =  30;

    classId() {

        return JoinRequestPacket.CLASSID;
    }
    public tableid : number;
    public seat : number;
    public params : Param[];

    constructor(tableid? : number, seat? : number, params? : Param[]) {
        this.tableid = tableid;
        this.seat = seat;
        this.params = params;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
    }
}
export class JoinResponsePacket implements ProtocolObject {
    static CLASSID : number =  31;

    classId() {

        return JoinResponsePacket.CLASSID;
    }
    public tableid : number;
    public seat : number;
    public status : JoinResponseStatus = 0;
    public code : number;

    constructor(tableid? : number, seat? : number, status? : JoinResponseStatus, code? : number) {
        this.tableid = tableid;
        this.seat = seat;
        this.status = status;
        this.code = code;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        ba.writeInt(this.code);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        this.status = ba.readUnsignedByte();
        this.code = ba.readInt();
    }
}
export class WatchRequestPacket implements ProtocolObject {
    static CLASSID : number =  32;

    classId() {

        return WatchRequestPacket.CLASSID;
    }
    public tableid : number;

    constructor(tableid? : number) {
        this.tableid = tableid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
    }
}
export class WatchResponsePacket implements ProtocolObject {
    static CLASSID : number =  33;

    classId() {

        return WatchResponsePacket.CLASSID;
    }
    public tableid : number;
    public status : WatchResponseStatus = 0;

    constructor(tableid? : number, status? : WatchResponseStatus) {
        this.tableid = tableid;
        this.status = status;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.status = ba.readUnsignedByte();
    }
}
export class UnwatchRequestPacket implements ProtocolObject {
    static CLASSID : number =  34;

    classId() {

        return UnwatchRequestPacket.CLASSID;
    }
    public tableid : number;

    constructor(tableid? : number) {
        this.tableid = tableid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
    }
}
export class UnwatchResponsePacket implements ProtocolObject {
    static CLASSID : number =  35;

    classId() {

        return UnwatchResponsePacket.CLASSID;
    }
    public tableid : number;
    public status : ResponseStatus = 0;

    constructor(tableid? : number, status? : ResponseStatus) {
        this.tableid = tableid;
        this.status = status;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.status = ba.readUnsignedByte();
    }
}
export class LeaveRequestPacket implements ProtocolObject {
    static CLASSID : number =  36;

    classId() {

        return LeaveRequestPacket.CLASSID;
    }
    public tableid : number;

    constructor(tableid? : number) {
        this.tableid = tableid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
    }
}
export class LeaveResponsePacket implements ProtocolObject {
    static CLASSID : number =  37;

    classId() {

        return LeaveResponsePacket.CLASSID;
    }
    public tableid : number;
    public status : ResponseStatus = 0;
    public code : number;

    constructor(tableid? : number, status? : ResponseStatus, code? : number) {
        this.tableid = tableid;
        this.status = status;
        this.code = code;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        ba.writeInt(this.code);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.status = ba.readUnsignedByte();
        this.code = ba.readInt();
    }
}
export class TableQueryRequestPacket implements ProtocolObject {
    static CLASSID : number =  38;

    classId() {

        return TableQueryRequestPacket.CLASSID;
    }
    public tableid : number;

    constructor(tableid? : number) {
        this.tableid = tableid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
    }
}
export class TableQueryResponsePacket implements ProtocolObject {
    static CLASSID : number =  39;

    classId() {

        return TableQueryResponsePacket.CLASSID;
    }
    public tableid : number;
    public status : ResponseStatus = 0;
    public seats : SeatInfoPacket[];

    constructor(tableid? : number, status? : ResponseStatus, seats? : SeatInfoPacket[]) {
        this.tableid = tableid;
        this.status = status;
        this.seats = seats;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        if (!this.seats) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.seats.length);
            for(let i = 0; i != this.seats.length; ++i)
                this.seats[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.status = ba.readUnsignedByte();
        let seatsCount : number = ba.readInt();
        this.seats = [];
        for(let i = 0; i != seatsCount; ++i) {
            let _tmp : SeatInfoPacket = new SeatInfoPacket();
            _tmp.load(ba);
            this.seats.push(_tmp);
        }
    }
}
export class CreateTableRequestPacket implements ProtocolObject {
    static CLASSID : number =  40;

    classId() {

        return CreateTableRequestPacket.CLASSID;
    }
    public seq : number;
    public gameid : number;
    public seats : number;
    public params : Param[];
    invitees : number[]  = [];

    constructor(seq? : number, gameid? : number, seats? : number, params? : Param[], invitees? : number[]) {
        this.seq = seq;
        this.gameid = gameid;
        this.seats = seats;
        this.params = params;
        this.invitees = invitees;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.seq);
        ba.writeInt(this.gameid);
        ba.writeByte(this.seats);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
        ba.writeInt(this.invitees.length);
        for(let i = 0; i != this.invitees.length; ++i) {
            ba.writeInt(this.invitees[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.seq = ba.readInt();
        this.gameid = ba.readInt();
        this.seats = ba.readByte();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
        let inviteesCount : number = ba.readInt();
        this.invitees = [];
        for (let i = 0; i < inviteesCount; i ++) {
            this.invitees.push(ba.readInt());
        }
    }
}
export class CreateTableResponsePacket implements ProtocolObject {
    static CLASSID : number =  41;

    classId() {

        return CreateTableResponsePacket.CLASSID;
    }
    public seq : number;
    public tableid : number;
    public seat : number;
    public status : ResponseStatus = 0;
    public code : number;

    constructor(seq? : number, tableid? : number, seat? : number, status? : ResponseStatus, code? : number) {
        this.seq = seq;
        this.tableid = tableid;
        this.seat = seat;
        this.status = status;
        this.code = code;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.seq);
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
        ba.writeInt(this.code);
    }

    public load(ba : ByteArray) : void {
        this.seq = ba.readInt();
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        this.status = ba.readUnsignedByte();
        this.code = ba.readInt();
    }
}
export class InvitePlayersRequestPacket implements ProtocolObject {
    static CLASSID : number =  42;

    classId() {

        return InvitePlayersRequestPacket.CLASSID;
    }
    public tableid : number;
    invitees : number[]  = [];

    constructor(tableid? : number, invitees? : number[]) {
        this.tableid = tableid;
        this.invitees = invitees;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeInt(this.invitees.length);
        for(let i = 0; i != this.invitees.length; ++i) {
            ba.writeInt(this.invitees[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        let inviteesCount : number = ba.readInt();
        this.invitees = [];
        for (let i = 0; i < inviteesCount; i ++) {
            this.invitees.push(ba.readInt());
        }
    }
}
export class NotifyInvitedPacket implements ProtocolObject {
    static CLASSID : number =  43;

    classId() {

        return NotifyInvitedPacket.CLASSID;
    }
    public inviter : number;
    public screenname : string;
    public tableid : number;
    public seat : number;

    constructor(inviter? : number, screenname? : string, tableid? : number, seat? : number) {
        this.inviter = inviter;
        this.screenname = screenname;
        this.tableid = tableid;
        this.seat = seat;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.inviter);
        ba.writeString(this.screenname);
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
    }

    public load(ba : ByteArray) : void {
        this.inviter = ba.readInt();
        this.screenname = ba.readString();
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
    }
}
export class NotifyJoinPacket implements ProtocolObject {
    static CLASSID : number =  60;

    classId() {

        return NotifyJoinPacket.CLASSID;
    }
    public tableid : number;
    public pid : number;
    public nick : string;
    public seat : number;

    constructor(tableid? : number, pid? : number, nick? : string, seat? : number) {
        this.tableid = tableid;
        this.pid = pid;
        this.nick = nick;
        this.seat = seat;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeInt(this.pid);
        ba.writeString(this.nick);
        ba.writeByte(this.seat);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.pid = ba.readInt();
        this.nick = ba.readString();
        this.seat = ba.readByte();
    }
}
export class NotifyLeavePacket implements ProtocolObject {
    static CLASSID : number =  61;

    classId() {

        return NotifyLeavePacket.CLASSID;
    }
    public tableid : number;
    public pid : number;

    constructor(tableid? : number, pid? : number) {
        this.tableid = tableid;
        this.pid = pid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeInt(this.pid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.pid = ba.readInt();
    }
}
export class TournamentRegistration implements ProtocolObject {
    static CLASSID : number =  212;

    classId() {

        return TournamentRegistration.CLASSID;
    }
    public tournamentId : number;
    public currencyCode : string;
    public canUnregister : boolean;
    public hasLobby : boolean;

    constructor(tournamentId? : number, currencyCode? : string, canUnregister? : boolean, hasLobby? : boolean) {
        this.tournamentId = tournamentId;
        this.currencyCode = currencyCode;
        this.canUnregister = canUnregister;
        this.hasLobby = hasLobby;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tournamentId);
        ba.writeString(this.currencyCode);
        ba.writeBoolean(this.canUnregister);
        ba.writeBoolean(this.hasLobby);
    }

    public load(ba : ByteArray) : void {
        this.tournamentId = ba.readInt();
        this.currencyCode = ba.readString();
        this.canUnregister = ba.readBoolean();
        this.hasLobby = ba.readBoolean();
    }
}
export class NotifyRegisteredPacket implements ProtocolObject {
    static CLASSID : number =  211;

    classId() {

        return NotifyRegisteredPacket.CLASSID;
    }
    public tournaments : TournamentRegistration[];

    constructor(tournaments? : TournamentRegistration[]) {
        this.tournaments = tournaments;
    }

    public save(ba : ByteArray) :  void {
        if (!this.tournaments) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.tournaments.length);
            for(let i = 0; i != this.tournaments.length; ++i)
                this.tournaments[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let tournamentsCount : number = ba.readInt();
        this.tournaments = [];
        for(let i = 0; i != tournamentsCount; ++i) {
            let _tmp : TournamentRegistration = new TournamentRegistration();
            _tmp.load(ba);
            this.tournaments.push(_tmp);
        }
    }
}
export class NotifyWatchingPacket implements ProtocolObject {
    static CLASSID : number =  63;

    classId() {

        return NotifyWatchingPacket.CLASSID;
    }
    public tableid : number;

    constructor(tableid? : number) {
        this.tableid = tableid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
    }
}
export class KickPlayerPacket implements ProtocolObject {
    static CLASSID : number =  64;

    classId() {

        return KickPlayerPacket.CLASSID;
    }
    public tableid : number;
    public reasonCode : number;

    constructor(tableid? : number, reasonCode? : number) {
        this.tableid = tableid;
        this.reasonCode = reasonCode;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeShort(this.reasonCode);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.reasonCode = ba.readShort();
    }
}
export class TableChatPacket implements ProtocolObject {
    static CLASSID : number =  80;

    classId() {

        return TableChatPacket.CLASSID;
    }
    public tableid : number;
    public pid : number;
    public message : string;

    constructor(tableid? : number, pid? : number, message? : string) {
        this.tableid = tableid;
        this.pid = pid;
        this.message = message;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeInt(this.pid);
        ba.writeString(this.message.substring(0, 280));
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.pid = ba.readInt();
        this.message = ba.readString();
    }
}
export class GameTransportPacket implements ProtocolObject {
    static CLASSID : number =  100;

    classId() {

        return GameTransportPacket.CLASSID;
    }
    public tableid : number;
    public pid : number;
    public gamedata : number[];
    public attributes : Attribute[];
    public roundSequence : number;
    public gameActionSequence : number;

    constructor(tableid? : number, pid? : number, gamedata? : number[], attributes? : Attribute[], roundSequence? : number, gameActionSequence? : number) {
        this.tableid = tableid;
        this.pid = pid;
        this.gamedata = gamedata;
        this.attributes = attributes;
        this.roundSequence = roundSequence;
        this.gameActionSequence = gameActionSequence;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeInt(this.pid);
        ba.writeInt(this.gamedata.length);
        for(let i = 0; i != this.gamedata.length; ++i) {
            ba.writeUnsignedByte(this.gamedata[i]);
        }
        if (!this.attributes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.attributes.length);
            for(let i = 0; i != this.attributes.length; ++i)
                this.attributes[i].save(ba);
        }
        ba.writeInt(this.roundSequence);
        ba.writeInt(this.gameActionSequence);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.pid = ba.readInt();
        let a = ba.readInt();
        this.gamedata = ba.readArray(a);
        let attributesCount : number = ba.readInt();
        this.attributes = [];
        for(let i = 0; i != attributesCount; ++i) {
            let _tmp : Attribute = new Attribute();
            _tmp.load(ba);
            this.attributes.push(_tmp);
        }
        this.roundSequence = ba.readInt();
        this.gameActionSequence = ba.readInt();
    }
}
export class ServiceTransportPacket implements ProtocolObject {
    static CLASSID : number =  101;

    classId() {

        return ServiceTransportPacket.CLASSID;
    }
    public pid : number;
    public seq : number;
    public service : string;
    public idtype : number;
    public servicedata : number[];
    public attributes : Attribute[];

    constructor(pid? : number, seq? : number, service? : string, idtype? : number, servicedata? : number[], attributes? : Attribute[]) {
        this.pid = pid;
        this.seq = seq;
        this.service = service;
        this.idtype = idtype;
        this.servicedata = servicedata;
        this.attributes = attributes;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.pid);
        ba.writeInt(this.seq);
        ba.writeString(this.service);
        ba.writeByte(this.idtype);
        ba.writeInt(this.servicedata.length);
        for(let i = 0; i != this.servicedata.length; ++i) {
            ba.writeUnsignedByte(this.servicedata[i]);
        }
        if (!this.attributes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.attributes.length);
            for(let i = 0; i != this.attributes.length; ++i)
                this.attributes[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.pid = ba.readInt();
        this.seq = ba.readInt();
        this.service = ba.readString();
        this.idtype = ba.readByte();
        let a = ba.readInt();
        this.servicedata = ba.readArray(a);
        let attributesCount : number = ba.readInt();
        this.attributes = [];
        for(let i = 0; i != attributesCount; ++i) {
            let _tmp : Attribute = new Attribute();
            _tmp.load(ba);
            this.attributes.push(_tmp);
        }
    }
}
export class LocalServiceTransportPacket implements ProtocolObject {
    static CLASSID : number =  103;

    classId() {

        return LocalServiceTransportPacket.CLASSID;
    }
    public seq : number;
    public servicedata : number[];

    constructor(seq? : number, servicedata? : number[]) {
        this.seq = seq;
        this.servicedata = servicedata;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.seq);
        ba.writeInt(this.servicedata.length);
        for(let i = 0; i != this.servicedata.length; ++i) {
            ba.writeUnsignedByte(this.servicedata[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.seq = ba.readInt();
        let a = ba.readInt();
        this.servicedata = ba.readArray(a);
    }
}
export class MttTransportPacket implements ProtocolObject {
    static CLASSID : number =  104;

    classId() {

        return MttTransportPacket.CLASSID;
    }
    public mttid : number;
    public pid : number;
    public mttdata : number[];
    public attributes : Attribute[];

    constructor(mttid? : number, pid? : number, mttdata? : number[], attributes? : Attribute[]) {
        this.mttid = mttid;
        this.pid = pid;
        this.mttdata = mttdata;
        this.attributes = attributes;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        ba.writeInt(this.pid);
        ba.writeInt(this.mttdata.length);
        for(let i = 0; i != this.mttdata.length; ++i) {
            ba.writeUnsignedByte(this.mttdata[i]);
        }
        if (!this.attributes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.attributes.length);
            for(let i = 0; i != this.attributes.length; ++i)
                this.attributes[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        this.pid = ba.readInt();
        let a = ba.readInt();
        this.mttdata = ba.readArray(a);
        let attributesCount : number = ba.readInt();
        this.attributes = [];
        for(let i = 0; i != attributesCount; ++i) {
            let _tmp : Attribute = new Attribute();
            _tmp.load(ba);
            this.attributes.push(_tmp);
        }
    }
}
export class EncryptedTransportPacket implements ProtocolObject {
    static CLASSID : number =  105;

    classId() {

        return EncryptedTransportPacket.CLASSID;
    }
    public func : number;
    public payload : number[];

    constructor(func? : number, payload? : number[]) {
        this.func = func;
        this.payload = payload;
    }

    public save(ba : ByteArray) :  void {
        ba.writeByte(this.func);
        ba.writeInt(this.payload.length);
        for(let i = 0; i != this.payload.length; ++i) {
            ba.writeUnsignedByte(this.payload[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.func = ba.readByte();
        let a = ba.readInt();
        this.payload = ba.readArray(a);
    }
}
export class LobbyQueryPacket implements ProtocolObject {
    static CLASSID : number =  142;

    classId() {

        return LobbyQueryPacket.CLASSID;
    }
    public gameid : number;
    public address : string;
    public type : LobbyType = 0;

    constructor(gameid? : number, address? : string, type? : LobbyType) {
        this.gameid = gameid;
        this.address = address;
        this.type = type;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.gameid);
        ba.writeString(this.address);
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
    }

    public load(ba : ByteArray) : void {
        this.gameid = ba.readInt();
        this.address = ba.readString();
        this.type = ba.readUnsignedByte();
    }
}
export class TableSnapshotPacket implements ProtocolObject {
    static CLASSID : number =  143;

    classId() {

        return TableSnapshotPacket.CLASSID;
    }
    public tableid : number;
    public address : string;
    public name : string;
    public capacity : number;
    public seated : number;
    public params : Param[];

    constructor(tableid? : number, address? : string, name? : string, capacity? : number, seated? : number, params? : Param[]) {
        this.tableid = tableid;
        this.address = address;
        this.name = name;
        this.capacity = capacity;
        this.seated = seated;
        this.params = params;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeString(this.address);
        ba.writeString(this.name);
        ba.writeShort(this.capacity);
        ba.writeShort(this.seated);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.address = ba.readString();
        this.name = ba.readString();
        this.capacity = ba.readShort();
        this.seated = ba.readShort();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
    }
}
export class TableUpdatePacket implements ProtocolObject {
    static CLASSID : number =  144;

    classId() {

        return TableUpdatePacket.CLASSID;
    }
    public tableid : number;
    public seated : number;
    public params : Param[];
    public removedParams : string[];

    constructor(tableid? : number, seated? : number, params? : Param[], removedParams? : string[]) {
        this.tableid = tableid;
        this.seated = seated;
        this.params = params;
        this.removedParams = removedParams;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeShort(this.seated);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
        if (!this.removedParams) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.removedParams.length);
            for(let i = 0; i != this.removedParams.length; ++i)
                ba.writeString(this.removedParams[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.seated = ba.readShort();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
        let removedParamsCount : number = ba.readInt();
        this.removedParams = [];
        for (let i = 0; i < removedParamsCount; i ++) {
            this.removedParams.push(ba.readString());
        }
    }
}
export class LobbySubscribePacket implements ProtocolObject {
    static CLASSID : number =  145;

    classId() {

        return LobbySubscribePacket.CLASSID;
    }
    public type : LobbyType = 0;
    public gameid : number;
    public address : string;

    constructor(type? : LobbyType, gameid? : number, address? : string) {
        this.type = type;
        this.gameid = gameid;
        this.address = address;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
        ba.writeInt(this.gameid);
        ba.writeString(this.address);
    }

    public load(ba : ByteArray) : void {
        this.type = ba.readUnsignedByte();
        this.gameid = ba.readInt();
        this.address = ba.readString();
    }
}
export class LobbyUnsubscribePacket implements ProtocolObject {
    static CLASSID : number =  146;

    classId() {

        return LobbyUnsubscribePacket.CLASSID;
    }
    public type : LobbyType = 0;
    public gameid : number;
    public address : string;

    constructor(type? : LobbyType, gameid? : number, address? : string) {
        this.type = type;
        this.gameid = gameid;
        this.address = address;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
        ba.writeInt(this.gameid);
        ba.writeString(this.address);
    }

    public load(ba : ByteArray) : void {
        this.type = ba.readUnsignedByte();
        this.gameid = ba.readInt();
        this.address = ba.readString();
    }
}
export class TableRemovedPacket implements ProtocolObject {
    static CLASSID : number =  147;

    classId() {

        return TableRemovedPacket.CLASSID;
    }
    public tableid : number;

    constructor(tableid? : number) {
        this.tableid = tableid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
    }
}
export class TournamentSnapshotPacket implements ProtocolObject {
    static CLASSID : number =  148;

    classId() {

        return TournamentSnapshotPacket.CLASSID;
    }
    public mttid : number;
    public address : string;
    public params : Param[];

    constructor(mttid? : number, address? : string, params? : Param[]) {
        this.mttid = mttid;
        this.address = address;
        this.params = params;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        ba.writeString(this.address);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        this.address = ba.readString();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
    }
}
export class TournamentUpdatePacket implements ProtocolObject {
    static CLASSID : number =  149;

    classId() {

        return TournamentUpdatePacket.CLASSID;
    }
    public mttid : number;
    public params : Param[];
    public removedParams : string[];

    constructor(mttid? : number, params? : Param[], removedParams? : string[]) {
        this.mttid = mttid;
        this.params = params;
        this.removedParams = removedParams;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
        if (!this.removedParams) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.removedParams.length);
            for(let i = 0; i != this.removedParams.length; ++i)
                ba.writeString(this.removedParams[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
        let removedParamsCount : number = ba.readInt();
        this.removedParams = [];
        for (let i = 0; i < removedParamsCount; i ++) {
            this.removedParams.push(ba.readString());
        }
    }
}
export class TournamentRemovedPacket implements ProtocolObject {
    static CLASSID : number =  150;

    classId() {

        return TournamentRemovedPacket.CLASSID;
    }
    public mttid : number;

    constructor(mttid? : number) {
        this.mttid = mttid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
    }
}
export class LobbyObjectSubscribePacket implements ProtocolObject {
    static CLASSID : number =  151;

    classId() {

        return LobbyObjectSubscribePacket.CLASSID;
    }
    public type : LobbyType = 0;
    public gameid : number;
    public address : string;
    public objectid : number;

    constructor(type? : LobbyType, gameid? : number, address? : string, objectid? : number) {
        this.type = type;
        this.gameid = gameid;
        this.address = address;
        this.objectid = objectid;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
        ba.writeInt(this.gameid);
        ba.writeString(this.address);
        ba.writeInt(this.objectid);
    }

    public load(ba : ByteArray) : void {
        this.type = ba.readUnsignedByte();
        this.gameid = ba.readInt();
        this.address = ba.readString();
        this.objectid = ba.readInt();
    }
}
export class LobbyObjectUnsubscribePacket implements ProtocolObject {
    static CLASSID : number =  152;

    classId() {

        return LobbyObjectUnsubscribePacket.CLASSID;
    }
    public type : LobbyType = 0;
    public gameid : number;
    public address : string;
    public objectid : number;

    constructor(type? : LobbyType, gameid? : number, address? : string, objectid? : number) {
        this.type = type;
        this.gameid = gameid;
        this.address = address;
        this.objectid = objectid;
    }

    public save(ba : ByteArray) :  void {
        if (typeof(this.type) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.type);
        }
        ba.writeInt(this.gameid);
        ba.writeString(this.address);
        ba.writeInt(this.objectid);
    }

    public load(ba : ByteArray) : void {
        this.type = ba.readUnsignedByte();
        this.gameid = ba.readInt();
        this.address = ba.readString();
        this.objectid = ba.readInt();
    }
}
export class TableSnapshotListPacket implements ProtocolObject {
    static CLASSID : number =  153;

    classId() {

        return TableSnapshotListPacket.CLASSID;
    }
    public snapshots : TableSnapshotPacket[];

    constructor(snapshots? : TableSnapshotPacket[]) {
        this.snapshots = snapshots;
    }

    public save(ba : ByteArray) :  void {
        if (!this.snapshots) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.snapshots.length);
            for(let i = 0; i != this.snapshots.length; ++i)
                this.snapshots[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let snapshotsCount : number = ba.readInt();
        this.snapshots = [];
        for(let i = 0; i != snapshotsCount; ++i) {
            let _tmp : TableSnapshotPacket = new TableSnapshotPacket();
            _tmp.load(ba);
            this.snapshots.push(_tmp);
        }
    }
}
export class TableUpdateListPacket implements ProtocolObject {
    static CLASSID : number =  154;

    classId() {

        return TableUpdateListPacket.CLASSID;
    }
    public updates : TableUpdatePacket[];

    constructor(updates? : TableUpdatePacket[]) {
        this.updates = updates;
    }

    public save(ba : ByteArray) :  void {
        if (!this.updates) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.updates.length);
            for(let i = 0; i != this.updates.length; ++i)
                this.updates[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let updatesCount : number = ba.readInt();
        this.updates = [];
        for(let i = 0; i != updatesCount; ++i) {
            let _tmp : TableUpdatePacket = new TableUpdatePacket();
            _tmp.load(ba);
            this.updates.push(_tmp);
        }
    }
}
export class TournamentSnapshotListPacket implements ProtocolObject {
    static CLASSID : number =  155;

    classId() {

        return TournamentSnapshotListPacket.CLASSID;
    }
    public snapshots : TournamentSnapshotPacket[];

    constructor(snapshots? : TournamentSnapshotPacket[]) {
        this.snapshots = snapshots;
    }

    public save(ba : ByteArray) :  void {
        if (!this.snapshots) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.snapshots.length);
            for(let i = 0; i != this.snapshots.length; ++i)
                this.snapshots[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let snapshotsCount : number = ba.readInt();
        this.snapshots = [];
        for(let i = 0; i != snapshotsCount; ++i) {
            let _tmp : TournamentSnapshotPacket = new TournamentSnapshotPacket();
            _tmp.load(ba);
            this.snapshots.push(_tmp);
        }
    }
}
export class TournamentUpdateListPacket implements ProtocolObject {
    static CLASSID : number =  156;

    classId() {

        return TournamentUpdateListPacket.CLASSID;
    }
    public updates : TournamentUpdatePacket[];

    constructor(updates? : TournamentUpdatePacket[]) {
        this.updates = updates;
    }

    public save(ba : ByteArray) :  void {
        if (!this.updates) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.updates.length);
            for(let i = 0; i != this.updates.length; ++i)
                this.updates[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        let updatesCount : number = ba.readInt();
        this.updates = [];
        for(let i = 0; i != updatesCount; ++i) {
            let _tmp : TournamentUpdatePacket = new TournamentUpdatePacket();
            _tmp.load(ba);
            this.updates.push(_tmp);
        }
    }
}
export class ProbeStamp implements ProtocolObject {
    static CLASSID : number =  200;

    classId() {

        return ProbeStamp.CLASSID;
    }
    public clazz : string;
    public timestamp : number;

    constructor(clazz? : string, timestamp? : number) {
        this.clazz = clazz;
        this.timestamp = timestamp;
    }

    public save(ba : ByteArray) :  void {
        ba.writeString(this.clazz);
        ba.writeLong(this.timestamp);
    }

    public load(ba : ByteArray) : void {
        this.clazz = ba.readString();
        this.timestamp = ba.readLong();
    }
}
export class ProbePacket implements ProtocolObject {
    static CLASSID : number =  201;

    classId() {

        return ProbePacket.CLASSID;
    }
    public id : number;
    public tableid : number;
    public stamps : ProbeStamp[];

    constructor(id? : number, tableid? : number, stamps? : ProbeStamp[]) {
        this.id = id;
        this.tableid = tableid;
        this.stamps = stamps;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.id);
        ba.writeInt(this.tableid);
        if (!this.stamps) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.stamps.length);
            for(let i = 0; i != this.stamps.length; ++i)
                this.stamps[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.id = ba.readInt();
        this.tableid = ba.readInt();
        let stampsCount : number = ba.readInt();
        this.stamps = [];
        for(let i = 0; i != stampsCount; ++i) {
            let _tmp : ProbeStamp = new ProbeStamp();
            _tmp.load(ba);
            this.stamps.push(_tmp);
        }
    }
}
export class MttRegisterRequestPacket implements ProtocolObject {
    static CLASSID : number =  205;

    classId() {

        return MttRegisterRequestPacket.CLASSID;
    }
    public mttid : number;
    public params : Param[];

    constructor(mttid? : number, params? : Param[]) {
        this.mttid = mttid;
        this.params = params;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        if (!this.params) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.params.length);
            for(let i = 0; i != this.params.length; ++i)
                this.params[i].save(ba);
        }
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        let paramsCount : number = ba.readInt();
        this.params = [];
        for(let i = 0; i != paramsCount; ++i) {
            let _tmp : Param = new Param();
            _tmp.load(ba);
            this.params.push(_tmp);
        }
    }
}
export class MttRegisterResponsePacket implements ProtocolObject {
    static CLASSID : number =  206;

    classId() {

        return MttRegisterResponsePacket.CLASSID;
    }
    public mttid : number;
    public status : TournamentRegisterResponseStatus = 0;

    constructor(mttid? : number, status? : TournamentRegisterResponseStatus) {
        this.mttid = mttid;
        this.status = status;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        this.status = ba.readUnsignedByte();
    }
}
export class MttUnregisterRequestPacket implements ProtocolObject {
    static CLASSID : number =  207;

    classId() {

        return MttUnregisterRequestPacket.CLASSID;
    }
    public mttid : number;

    constructor(mttid? : number) {
        this.mttid = mttid;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
    }
}
export class MttUnregisterResponsePacket implements ProtocolObject {
    static CLASSID : number =  208;

    classId() {

        return MttUnregisterResponsePacket.CLASSID;
    }
    public mttid : number;
    public status : TournamentRegisterResponseStatus = 0;

    constructor(mttid? : number, status? : TournamentRegisterResponseStatus) {
        this.mttid = mttid;
        this.status = status;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        if (typeof(this.status) == "undefined") {
            ba.writeUnsignedByte(-1);
        } else {
            ba.writeUnsignedByte(this.status);
        }
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        this.status = ba.readUnsignedByte();
    }
}
export class MttSeatedPacket implements ProtocolObject {
    static CLASSID : number =  209;

    classId() {

        return MttSeatedPacket.CLASSID;
    }
    public mttid : number;
    public tableid : number;
    public seat : number;
    public currencyCode : string;

    constructor(mttid? : number, tableid? : number, seat? : number, currencyCode? : string) {
        this.mttid = mttid;
        this.tableid = tableid;
        this.seat = seat;
        this.currencyCode = currencyCode;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        ba.writeString(this.currencyCode);
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        this.currencyCode = ba.readString();
    }
}
export class MttPickedUpPacket implements ProtocolObject {
    static CLASSID : number =  210;

    classId() {

        return MttPickedUpPacket.CLASSID;
    }
    public mttid : number;
    public tableid : number;
    public keepWatching : boolean;

    constructor(mttid? : number, tableid? : number, keepWatching? : boolean) {
        this.mttid = mttid;
        this.tableid = tableid;
        this.keepWatching = keepWatching;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.mttid);
        ba.writeInt(this.tableid);
        ba.writeBoolean(this.keepWatching);
    }

    public load(ba : ByteArray) : void {
        this.mttid = ba.readInt();
        this.tableid = ba.readInt();
        this.keepWatching = ba.readBoolean();
    }
}
export class NotifySeatedPacket implements ProtocolObject {
    static CLASSID : number =  62;

    classId() {

        return NotifySeatedPacket.CLASSID;
    }
    public tableid : number;
    public seat : number;
    public mttid : number;
    public snapshot : TableSnapshotPacket;

    constructor(tableid? : number, seat? : number, mttid? : number, snapshot? : TableSnapshotPacket) {
        this.tableid = tableid;
        this.seat = seat;
        this.mttid = mttid;
        this.snapshot = snapshot;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        ba.writeInt(this.mttid);
        this.snapshot.save(ba);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        this.mttid = ba.readInt();
        this.snapshot = new TableSnapshotPacket();
        this.snapshot.load(ba);
    }
}
export class GameModeChangePacket implements ProtocolObject {
    static CLASSID : number =  65;

    classId() {

        return GameModeChangePacket.CLASSID;
    }
    public tableId : number;
    public message : string;
    public addModes : string[];
    public removeModes : string[];

    constructor(tableId? : number, message? : string, addModes? : string[], removeModes? : string[]) {
        this.tableId = tableId;
        this.message = message;
        this.addModes = addModes;
        this.removeModes = removeModes;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableId);
        ba.writeString(this.message);
        if (!this.addModes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.addModes.length);
            for(let i = 0; i != this.addModes.length; ++i)
                ba.writeString(this.addModes[i]);
        }
        if (!this.removeModes) {
            ba.writeInt(0);
        } else {
            ba.writeInt(this.removeModes.length);
            for(let i = 0; i != this.removeModes.length; ++i)
                ba.writeString(this.removeModes[i]);
        }
    }

    public load(ba : ByteArray) : void {
        this.tableId = ba.readInt();
        this.message = ba.readString();
        let addModesCount : number = ba.readInt();
        this.addModes = [];
        for (let i = 0; i < addModesCount; i ++) {
            this.addModes.push(ba.readString());
        }
        let removeModesCount : number = ba.readInt();
        this.removeModes = [];
        for (let i = 0; i < removeModesCount; i ++) {
            this.removeModes.push(ba.readString());
        }
    }
}
export class NotifySeatedPacketV2 implements ProtocolObject {
    static CLASSID : number =  66;

    classId() {

        return NotifySeatedPacketV2.CLASSID;
    }
    public tableid : number;
    public seat : number;
    public mttid : number;
    public snapshot : TableSnapshotPacket;
    public movedFrom : number;
    public tableType : number;

    constructor(tableid? : number, seat? : number, mttid? : number, snapshot? : TableSnapshotPacket, movedFrom? : number, tableType? : number) {
        this.tableid = tableid;
        this.seat = seat;
        this.mttid = mttid;
        this.snapshot = snapshot;
        this.movedFrom = movedFrom;
        this.tableType = tableType;
    }

    public save(ba : ByteArray) :  void {
        ba.writeInt(this.tableid);
        ba.writeByte(this.seat);
        ba.writeInt(this.mttid);
        this.snapshot.save(ba);
        ba.writeInt(this.movedFrom);
        ba.writeInt(this.tableType);
    }

    public load(ba : ByteArray) : void {
        this.tableid = ba.readInt();
        this.seat = ba.readByte();
        this.mttid = ba.readInt();
        this.snapshot = new TableSnapshotPacket();
        this.snapshot.load(ba);
        this.movedFrom = ba.readInt();
        this.tableType = ba.readInt();
    }
}

export enum ParameterType { STRING, INT, DATE }

export enum ParameterFilter { EQUALS, GREATER_THAN, SMALLER_THAN, EQUALS_OR_GREATER_THAN, EQUALS_OR_SMALLER_THAN }

export enum LobbyType { REGULAR, MTT }

export enum TournamentAttributes { NAME, CAPACITY, REGISTERED, ACTIVE_PLAYERS, STATUS }

export enum ServiceIdentifier { NAMESPACE, CONTRACT }

export enum PlayerStatus { CONNECTED, WAITING_REJOIN, DISCONNECTED, LEAVING, TABLE_LOCAL, RESERVATION }

export enum ResponseStatus { OK, FAILED, DENIED }

export enum JoinResponseStatus { OK, FAILED, DENIED }

export enum WatchResponseStatus { OK, FAILED, DENIED, DENIED_ALREADY_SEATED }

export enum TournamentRegisterResponseStatus { OK, FAILED, DENIED, DENIED_LOW_FUNDS, DENIED_MTT_FULL, DENIED_NO_ACCESS, DENIED_ALREADY_REGISTERED, DENIED_TOURNAMENT_RUNNING, DENIED_RUG_CONFLICT, DENIED_PASSWORD_INCORRECT, DENIED_REGISTERED_TO_TARGET, ALLOWED_AND_UNREGISTERED_FROM_SATELLITE, ALLOWED_ALREADY_PLAYING_SATELLITE, DENIED_NO_VALID_UNLOCK }

export enum ForcedLogoutCode { IDLE_TIMEOUT, LOGGED_IN_REMOTELY, KICKED }

export class ProtocolObjectFactory implements ObjectFactory {

    public  version() : number {
        return 8559;
    }

    public create(classId : number, ba : ByteArray)  : ProtocolObject {
        var obj = this.createClass(classId);
        obj.load(ba);
        return obj;
    }

    public createClass(classId:number) : ProtocolObject {
        switch(classId) {
            case 0:
                return new VersionPacket();
            case 1:
                return new GameVersionPacket();
            case 2:
                return new GoodPacket();
            case 3:
                return new BadPacket();
            case 4:
                return new SystemMessagePacket();
            case 5:
                return new Param();
            case 6:
                return new ParamFilter();
            case 7:
                return new PingPacket();
            case 8:
                return new Attribute();
            case 10:
                return new LoginRequestPacket();
            case 20:
                return new JwtAuthPacket();
            case 11:
                return new LoginResponsePacket();
            case 12:
                return new LogoutPacket();
            case 13:
                return new PlayerInfoPacket();
            case 14:
                return new ForcedLogoutPacket();
            case 15:
                return new SeatInfoPacket();
            case 18:
                return new SystemInfoRequestPacket();
            case 19:
                return new SystemInfoResponsePacket();
            case 30:
                return new JoinRequestPacket();
            case 31:
                return new JoinResponsePacket();
            case 32:
                return new WatchRequestPacket();
            case 33:
                return new WatchResponsePacket();
            case 34:
                return new UnwatchRequestPacket();
            case 35:
                return new UnwatchResponsePacket();
            case 36:
                return new LeaveRequestPacket();
            case 37:
                return new LeaveResponsePacket();
            case 38:
                return new TableQueryRequestPacket();
            case 39:
                return new TableQueryResponsePacket();
            case 40:
                return new CreateTableRequestPacket();
            case 41:
                return new CreateTableResponsePacket();
            case 42:
                return new InvitePlayersRequestPacket();
            case 43:
                return new NotifyInvitedPacket();
            case 60:
                return new NotifyJoinPacket();
            case 61:
                return new NotifyLeavePacket();
            case 212:
                return new TournamentRegistration();
            case 211:
                return new NotifyRegisteredPacket();
            case 63:
                return new NotifyWatchingPacket();
            case 64:
                return new KickPlayerPacket();
            case 80:
                return new TableChatPacket();
            case 100:
                return new GameTransportPacket();
            case 101:
                return new ServiceTransportPacket();
            case 103:
                return new LocalServiceTransportPacket();
            case 104:
                return new MttTransportPacket();
            case 105:
                return new EncryptedTransportPacket();
            case 142:
                return new LobbyQueryPacket();
            case 143:
                return new TableSnapshotPacket();
            case 144:
                return new TableUpdatePacket();
            case 145:
                return new LobbySubscribePacket();
            case 146:
                return new LobbyUnsubscribePacket();
            case 147:
                return new TableRemovedPacket();
            case 148:
                return new TournamentSnapshotPacket();
            case 149:
                return new TournamentUpdatePacket();
            case 150:
                return new TournamentRemovedPacket();
            case 151:
                return new LobbyObjectSubscribePacket();
            case 152:
                return new LobbyObjectUnsubscribePacket();
            case 153:
                return new TableSnapshotListPacket();
            case 154:
                return new TableUpdateListPacket();
            case 155:
                return new TournamentSnapshotListPacket();
            case 156:
                return new TournamentUpdateListPacket();
            case 200:
                return new ProbeStamp();
            case 201:
                return new ProbePacket();
            case 205:
                return new MttRegisterRequestPacket();
            case 206:
                return new MttRegisterResponsePacket();
            case 207:
                return new MttUnregisterRequestPacket();
            case 208:
                return new MttUnregisterResponsePacket();
            case 209:
                return new MttSeatedPacket();
            case 210:
                return new MttPickedUpPacket();
            case 62:
                return new NotifySeatedPacket();
            case 65:
                return new GameModeChangePacket();
            case 66:
                return new NotifySeatedPacketV2();
        }
        throw new Error("Unknown class id: " + classId);
    }
}

